import React, { useMemo } from 'react';
import { ColumnConfig, RichTableState } from './types';
import Stack from '../Stack';
import PressableDynamicOpacity from '../PressableDynamicOpacity';
import Icon, { IconColorVariant, IconSize } from '../Icon';
import { StyleProp, ViewStyle } from 'react-native';

export type SortToggleOwnProps = {
    columnConfig: ColumnConfig<any>;
    onStateChange: (newState: RichTableState) => void;
    state: RichTableState;
    data: any[];
    style?: StyleProp<ViewStyle>;
};

export type SortToggleProps = SortToggleOwnProps;

const SortToggle: React.FC<SortToggleProps> = (props) => {
    const enableSort = useMemo(() => {
        const hasAnySortValue = props.data.some(
            (dataElement) => props.columnConfig.getSortValue && props.columnConfig.getSortValue(dataElement) !== null,
        );
        return hasAnySortValue;
    }, [props.columnConfig, props.data]);

    if (!enableSort) {
        return null;
    }

    const columnSortState =
        props.state.sortState?.columnKey === props.columnConfig.columnKey ? props.state.sortState : null;

    const getSortClickHandler = (direction: 'asc' | 'desc') => () => {
        props.onStateChange({
            ...props.state,
            sortState:
                columnSortState?.direction === direction
                    ? undefined
                    : { columnKey: props.columnConfig.columnKey, direction },
        });
    };

    const getIconColor = (direction: 'asc' | 'desc'): IconColorVariant =>
        columnSortState?.direction === direction ? 'Dark-Text' : 'Gray-Text';

    const getIconSizeVariant = (direction: 'asc' | 'desc'): IconSize =>
        columnSortState?.direction === direction ? 'sort-toggle-selected' : 'sort-toggle-not-selected';

    return (
        <Stack vertical justify="center" align="center" style={props.style}>
            <PressableDynamicOpacity onPress={getSortClickHandler('asc')}>
                <Icon size={getIconSizeVariant('asc')} name="ChevronUp" color={getIconColor('asc')} />
            </PressableDynamicOpacity>
            <PressableDynamicOpacity onPress={getSortClickHandler('desc')}>
                <Icon size={getIconSizeVariant('desc')} name="ChevronDown" color={getIconColor('desc')} />
            </PressableDynamicOpacity>
        </Stack>
    );
};

export default React.memo(SortToggle);
